import { render, staticRenderFns } from "./TransactionHistory.vue?vue&type=template&id=605be59e"
import script from "./TransactionHistory.vue?vue&type=script&lang=js"
export * from "./TransactionHistory.vue?vue&type=script&lang=js"
import style0 from "./TransactionHistory.vue?vue&type=style&index=0&id=605be59e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports